import makeLookupModal from "../../UI/LookupModal/LookupModal";
import ProgramLookup from "./ProgramLookup";
const ProgramLookupModal = makeLookupModal(ProgramLookup, {
    pluralEntityName: "Programs",
});
export default ProgramLookupModal;
